<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__cost}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="外销合同号：">
          <el-input v-model="dataForm.orderCode" placeholder="请输入外销合同号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('trade:cost:save')" type="primary" @click="addOrUpdateHandle()">设置发货计划
          </el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
                style="width: 100%;">
        <el-table-column type="index" label="行号" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="orderCode" label="外销合同号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="code" label="品番号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="skuCode" label="SKU" header-align="center" align="center"></el-table-column>
        <el-table-column prop="name" label="品名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="color" label="颜色" header-align="center" align="center"></el-table-column>
        <el-table-column prop="size" label="规格" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sendDate" label="计划发货时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="count" label="计划发货数量" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('trade:cost:update')" type="text" size="small"
                       @click="changePlan(scope.row)">修改计划
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './save'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/plan/page',
        getDataListIsPage: true,
        exportURL: '/trade/cost/export',
        deleteURL: '/trade/cost',
        deleteIsBatch: true
      },
      dataForm: {
        name: '',
        orderCode: ''
      }
    }
  },
  methods: {
    changePlan (row) {
      this.addOrUpdateVisible=true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init()
        this.$refs.addOrUpdate.orderCode = row.orderCode
      })
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
